module.exports = __webpack_public_path__ + "static/img/artist-joey-banner@2x.108341c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-joey-banner@2x.png
// module id = RzLj
// module chunks = 13